// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'relations'

/**
 * Relation Model Interface (auto-generated from Drizzle schema)
 */
export interface RelationModel {
  id: string
  orgId: string
  workspaceId?: string
  userId?: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  sourceId: string
  sourceCollection: string
  sourceSchemaId?: string
  targetId: string
  targetCollection: string
  targetSchemaId?: string
  relationType: string
  data?: Record<string, unknown>
  sortOrder?: number
  label?: string
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "orgId": {
          "type": "string",
          "maxLength": 100
      },
      "workspaceId": {
          "type": "string",
          "maxLength": 100
      },
      "userId": {
          "type": "string",
          "maxLength": 100
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "sourceId": {
          "type": "string",
          "maxLength": 100
      },
      "sourceCollection": {
          "type": "string",
          "maxLength": 200
      },
      "sourceSchemaId": {
          "type": "string",
          "maxLength": 100
      },
      "targetId": {
          "type": "string",
          "maxLength": 100
      },
      "targetCollection": {
          "type": "string",
          "maxLength": 200
      },
      "targetSchemaId": {
          "type": "string",
          "maxLength": 100
      },
      "relationType": {
          "type": "string",
          "maxLength": 200
      },
      "data": {
          "type": "object"
      },
      "sortOrder": {
          "type": "integer",
          "minimum": 0,
          "maximum": 999999,
          "multipleOf": 1
      },
      "label": {
          "type": "string",
          "maxLength": 255
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      }
  },
  required: [
      "id",
      "orgId",
      "createdAt",
      "updatedAt",
      "sourceId",
      "sourceCollection",
      "targetId",
      "targetCollection",
      "relationType"
  ],
  indexes: [
      [
          "orgId",
          "sourceId",
          "relationType"
      ],
      [
          "orgId",
          "targetId",
          "relationType"
      ],
      [
          "orgId",
          "relationType"
      ],
      [
          "orgId",
          "createdAt"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
